import React from 'react'
import moment from 'moment';

export default function DayDifferennceTag({
    dateFormat = "YYYY-MM-DD",
    date, dateFrom,maxSuccessDay=7
}) {
    let _dateFrom=(dateFrom&&moment(dateFrom,dateFormat).isValid())?moment(dateFrom,dateFormat):moment();
    let _dateTo=date&&moment(date,dateFormat) ? moment(date,dateFormat):moment();

    let  diff_day=_dateFrom.diff(_dateTo,'day');
    return (
        <div title={date||"N/A"} className={`day-difference-tag 
        ${diff_day<0 ? 'danger':''}
        ${maxSuccessDay&&diff_day>=maxSuccessDay ?'danger':''}
        ${date==null?'disabled':''}
        `}>
            {date==null?
            "-":
            diff_day==0?`Today`:
            `${diff_day}d`
            }
        </div>
    )
}
